module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[60]425.3c44d83.woff2";